// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

// Use API_URL from environment if available, otherwise default to current location
const urlPrefix = process.env.API_URL ? 
  `${process.env.API_URL}/` : 
  `${document.location.protocol}//${document.location.host}/`

// Use FRONTEND_URL for share/embed URLs, otherwise default to current location  
const frontendUrlPrefix = process.env.FRONTEND_URL ? 
  `${process.env.FRONTEND_URL}/` : 
  `${document.location.protocol}//${document.location.host}/`

export default {
  urlPrefix,        // For API calls
  frontendUrlPrefix // For share/embed URLs
}
